import classNames from "classnames/bind";

import styles from "./Popup.module.scss";

interface IPopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const cx = classNames.bind(styles);

const Popup = ({ isOpen, onClose, children }: IPopupProps) => {
  const handleClose = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div>
      <div
        className={cx("popup-wrapper", isOpen && "open")}
        onClick={(e) => handleClose(e)}
      >
        <div className={cx("popup-inner", isOpen && "open")}>{isOpen && <>{children}</>}</div>
      </div>
    </div>
  );
};

export default Popup;
